import { render } from "./IngredientsDialog.vue?vue&type=template&id=4c872b69&ts=true"
import script from "./IngredientsDialog.vue?vue&type=script&lang=ts"
export * from "./IngredientsDialog.vue?vue&type=script&lang=ts"

import "./IngredientsDialog.vue?vue&type=style&index=0&id=4c872b69&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__